import getLang from 'I18n/utils/getLang';
import { useGetInstallabilityQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsRpc-app.hooks';
export function useInstallability({
  listingId,
  published = true,
  skip = false,
  appContext
}) {
  const {
    data: installabilityData,
    loading: installabilityLoading,
    error: installabilityError
  } = useGetInstallabilityQuery({
    variables: {
      listingId: listingId,
      listingLanguage: getLang(),
      published
    },
    skip: skip || !listingId || appContext !== 'app'
  });
  return {
    data: installabilityData,
    loading: installabilityLoading,
    error: installabilityError
  };
}